import React from 'react';
import './Card2.css';
import { Link } from 'react-router-dom';

const Card2 = () => {
  const programs = [
    {
      slug: 'formaciontecnicolaboral',
      title: 'Técnicos Laborales',
      description: 'Programas orientados al desarrollo de habilidades para el mundo laboral.',
      color: 'blue',
      icon: (
        /* Icono de Rejilla (Técnicos) */
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M4 4h4v4H4V4zm6 0h4v4h-4V4zm6 0h4v4h-4V4zM4 10h4v4H4v-4zm6 0h4v4h-4v-4zm6 0h4v4h-4v-4zM4 16h4v4H4v-4zm6 0h4v4h-4v-4zm6 0h4v4h-4v-4z" />
        </svg>
      ),
      linkText: 'ver tecnoico laboral'
    },
    {
      slug: 'cursos',
      title: 'Cursos Cortos',
      description: 'Aprende nuevos conocimientos en menos tiempo.',
      color: 'red',
      icon: (
        /* Icono Destello / Estrella (Cursos Cortos) */
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" />
        </svg>
      ),
      linkText: 'ver cursos'
    },
    {
      slug: 'diplomados',
      title: 'Diplomados',
      description: 'Profundiza tus conocimientos y especialízate.',
      color: 'blue',
      icon: (
        /* Icono Rombo Blanco Centrado (Diplomados) */
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <rect x="6" y="6" width="12" height="12" transform="rotate(45 12 12)" />
        </svg>
      ),
      linkText: 'Ver Diplomados'
    },
    /* {
      title: 'Seminarios',
      description: '',
      color: 'red',
      icon: null,
      linkText: null
    } */
  ];

  return (
    <section className="programs-section">
      <h2 className="section-title">Nuestros programas</h2>

      <div className="programs-grid">
        {programs.map((program, index) => (
          <div key={index} className="program-card">
            {/* Rombo / Hexágono contenedor con color */}
            <div className={`hexagon-container ${program.color}`}>
              {program.icon && <span className="hexagon-icon">{program.icon}</span>}
            </div>

            <h3 className="card-title">{program.title}</h3>
            {program.description && (
              <p className="card-description">{program.description}</p>
            )}

            {program.slug && program.linkText && (
              <Link to={`/${program.slug}`} className="card-link">
                {program.linkText} <span className="arrow">&rarr;</span>
              </Link>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Card2;
